import React from 'react';
import PropTypes from 'prop-types';

import { IComponent } from '../../../typings/generic-component';
import { makeClassNames, IClassNames } from '../../../utils/styles';
import './team-match-card-skeleton.scss';
import TeamMatchCardWrapper from '../../atoms/outlined-card/outlined-card';
import Skeleton from '../../atoms/skeleton/skeleton';

export interface ITeamMatchCardSkeleton extends IComponent {}

const classNames = (): IClassNames =>
  makeClassNames({
    root: 'team-match-card-skeleton',
    header: 'team-match-card-skeleton__header',
    content: 'team-match-card-skeleton__content',
  });

const TeamMatchCardSkeleton: React.FC<ITeamMatchCardSkeleton> = () => {
  const cn = classNames();
  return (
    <TeamMatchCardWrapper
      header={
        <div className={cn.header}>
          <Skeleton isText fontSize="16" width="8rem" colorSchema="dark-light" />
          <Skeleton isText fontSize="16" width="100%" colorSchema="dark-light" />
        </div>
      }
    >
      <div className={cn.content}>
        <Skeleton width="50px" height="50px" />
        <Skeleton isText fontSize="22" width="3rem" />
        <Skeleton width="50px" height="50px" />
      </div>
    </TeamMatchCardWrapper>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  TeamMatchCardSkeleton.propTypes = {
    children: PropTypes.node,
  };
}

export default TeamMatchCardSkeleton;
